// layouts/MainLayout/components/Footer/Footer.tsx
import styles from './Footer.module.css';
import DigiBrigiLogo from '../../../../components/common/DigiBrigiLogo/DigiBrigiLogo';

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.wrap}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <DigiBrigiLogo size={22} />
          {/* <p className={styles.tagline}>
            Moderní digitální brigáda. Využij matematickou výhodu bonusů a proměň pár hodin týdně
            v reálné peníze.
          </p> */}
        </div>

        <div className={styles.col}>
          <h4>Podpora</h4>
          <a href="https://src.algapia.cz/docs/VOP.pdf" target="_blank" rel="noopener noreferrer">
            Všeobecné obchodní podmínky
          </a>
          <a href="https://src.algapia.cz/docs/GDPR.pdf" target="_blank" rel="noopener noreferrer">
            Ochrana osobních údajů
          </a>
          <a href="/#faq">Časté otázky</a>
        </div>

        <div className={styles.col}>
          <h4>Máš dotazy?</h4>
          <a href="mailto:algapia@algapia.cz">algapia@algapia.cz</a>
        </div>
      </div>

      <div className={styles.bottom}>
        <div className={styles.copy}>© {new Date().getFullYear()} ALGAPIA. Všechna práva vyhrazena.</div>
        {/* <div className={styles.disclaimer}>
          DigiBrigi poskytuje analytické nástroje a návody. Nevyplácí výhry a negarantuje zisk.
          <br />
          Ministerstvo financí varuje: Účastí na hazardní hře může vzniknout závislost! Hazardní hry
          jsou pro osoby starší 18 let.
        </div> */}
      </div>
    </div>
  </footer>
);

export default Footer;
